import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service to set loading state
 * Deprecated, this is not how to handle loading state in Angular
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(true); // Will be set to false on app initialization

  subscribeToCurrentLoadingState(): Observable<boolean> {
    return this.loading.asObservable();
  }

  setCurrentLoadingState(value: boolean) {
    this.loading.next(value);
  }
}
